import React from "react"
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts"

export default function FarmGrowth({ activeFarmDetails }) {
  const sstData = activeFarmDetails.wave_buoy_to_farms[0]
    ? activeFarmDetails.wave_buoy_to_farms[0].wave_buoy.wave_buoy_data
        .filter((data) => data.measurement === "SST (degC)")
        .map((data) => {
          return {
            date: data.measurement_date,
            waterTemp: data.value,
          }
        })
    : []
  const wave_data = activeFarmDetails.wave_buoy_to_farms
    ? activeFarmDetails.wave_buoy_to_farms[0].wave_buoy?.wave_buoy_data
        ?.filter((data) => data.measurement === "Hsig (m)")
        .map((data) => {
          return {
            date: data.measurement_date,
            waveHeight: data.value,
          }
        })
    : []

  const data = [...sstData, ...wave_data].sort((a, b) => {
    return new Date(a.date) - new Date(b.date)
  })

  // sstData and wave_data computed for charting
  return (
    <div style={{ height: 300 }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data}
          margin={{
            top: 10,
            right: 0,
            left: 0,
            bottom: 10,
          }}
        >
          {/* Make grid deterministic when multiple axes exist by specifying axis ids */}
          <CartesianGrid strokeDasharray="3 3" xAxisId="bottom" yAxisId="left" />
          <XAxis dataKey="date" xAxisId="bottom" />
          <YAxis yAxisId="left" id="left" />
          <YAxis yAxisId="right" id="right" orientation="right" />
          <Tooltip />
          <Legend />
          <Line
            yAxisId="left"
            type="monotone"
            dataKey="waveHeight"
            stroke="#8884d8"
            activeDot={{ r: 8 }}
          />
          <Line
            yAxisId="right"
            type="monotone"
            dataKey="waterTemp"
            stroke="#82ca9d"
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  )
}
